/* eslint-disable */
import React, { Component, createContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import is from 'is_js'
import { connect } from 'react-redux'
import { setWalletConnectURI, setIsconnectedWithWallet } from '../../redux/walletConnect/action'

import WalletConnectClient from '../../utils/integrations/walletConnectClient'
import { Consumer as BNCClientConsumer } from './BNCClientProvider'
import Modal from '../../components/common/Modal'
import Notifycation from '../../components/common/Notifycation'
import { isUnlockWithWalletConnect } from '../../utils/account'
import { refresh } from '../../utils/bomUtils'
import httpRequest from '../../utils/httpRequest'
import { saveAddress } from '../../utils/storage'

import { withI18n } from '../../i18n/util'

const BRIDGE_URI = null // use default

const ModalBody = styled.div`
  color: inherit;
  text-align: center;
  background: ${({ theme }) => theme.popupBg};
  box-shadow: ${({ theme }) => theme.boxShadow};
`

/* **** */

const WalletConnectDelegateConfigurator = ({
  bncClient,
  walletConnectClient,
  preSignCb,
  postSignCb,
  errCb,
  isClientInitailized,
}) => {
  // similar to componentDidMount and componentDidUpdate:
  useEffect(() => {
    if (!bncClient || !walletConnectClient) return
    if (!isUnlockWithWalletConnect()) return
    if (!isClientInitailized) return
    const delegate = walletConnectClient.getSigningDelegate(preSignCb, postSignCb, errCb)
    console.log('Setting WalletConnect signing delegate on BncClient.')
    bncClient.setSigningDelegate(delegate)
  })
  return null
}

WalletConnectDelegateConfigurator.propTypes = {
  bncClient: PropTypes.object.isRequired,
  walletConnectClient: PropTypes.object.isRequired,
  isClientInitailized: PropTypes.bool.isRequired,
  preSignCb: PropTypes.func,
  postSignCb: PropTypes.func,
}

WalletConnectDelegateConfigurator.defaultProps = {
  preSignCb: () => {},
  postSignCb: () => {},
}

/* **** */

const Context = createContext({})

class WalletConnectProvider extends Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
    dispatch: PropTypes.func.isRequired,
    triggerElement: PropTypes.element,
    formatI18nText: PropTypes.func,
    address: PropTypes.string,
    isWalletConnect: PropTypes.bool,
    isConnectedWithWallet: PropTypes.bool,
  }

  static defaultProps = {
    triggerElement: null,
    address: '',
    formatI18nText: () => {},
    isWalletConnect: false,
    isConnectedWithWallet: false,
  }

  constructor(props) {
    super(props)
    this._client = new WalletConnectClient(BRIDGE_URI)
    this._client.on('connect', this._onConnect)
    this._client.on('resotre', this._onResotre)
    this._client.on('disconnect', this._onDisconnect)
    this._client.on('session_update', this._onSessionUpdate)
    this.state = {
      showModal: false,
      showNotify: false,
    }
  }

  componentDidMount() {
    window.addEventListener('load', this._pageLoad)
    window.addEventListener('unload', this._pageUnLoad)
  }

  componentWillUnmount() {
    window.removeEventListener('load', this._pageLoad)
    // window.removeEventListener('onbeforeunload', this._pageUnLoad)
  }

  componentDidUpdate(prevProps) {
    const { isConnectedWithWallet } = this.props
    if (isConnectedWithWallet !== prevProps.isConnectedWithWallet) {
      this.setState({ showNotify: true })
    }
  }

  _pageUnLoad = e => {
    this._client.disconnect()
  }

  _pageLoad = async () => {
    let walletConnect = localStorage.getItem('walletconnect')
    walletConnect = walletConnect && JSON.parse(walletConnect)
    try {
      if (walletConnect && walletConnect.handshakeTopic) {
        const checkResult = await httpRequest.checkTopic(walletConnect.handshakeTopic)

        if (checkResult && checkResult.isAlive) {
          this._client.restoreSession()
        } else {
          //clear unalive session
          localStorage.removeItem('walletconnect')
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  _onResotre = () => {
    const { dispatch } = this.props
    dispatch(setIsconnectedWithWallet(true))
  }

  _onConnect = ({ accounts }) => {
    const { dispatch, triggerElement } = this.props
    let user = sessionStorage.getItem('user')
    user = (user && JSON.parse(user)) || {}
    if (!user.address) {
      return
    }

    if (accounts[0] !== user.address) {
      saveAddress(accounts[0])
      if (!location.pathname.includes('/unlock')) {
        refresh()
      }
    } else {
      dispatch(setWalletConnectURI(''))
      dispatch(setIsconnectedWithWallet(true))
      if (triggerElement && is.function(triggerElement.click)) {
        triggerElement.click()
      }
    }
  }

  _onDisconnect = () => {
    const { dispatch } = this.props
    console.log('WalletConnect session disconnected')
    dispatch(setWalletConnectURI(''))
    dispatch(setIsconnectedWithWallet(false))
  }

  _onSessionUpdate = params => {
    console.log('updated params...')
    console.log(params)
    const { dispatch, triggerElement } = this.props
    dispatch(setWalletConnectURI(''))
    if (triggerElement && is.function(triggerElement.click)) {
      triggerElement.click()
    }
  }

  _showSignModal = () => {
    this.setState({ showModal: true })
  }

  _hideSignModal = () => {
    this.setState({ showModal: false })
  }

  render() {
    const { showModal, showNotify } = this.state
    const { children, formatI18nText, isWalletConnect, isConnectedWithWallet } = this.props

    const notifyMsg = isConnectedWithWallet
      ? 'Mobile Wallet connected'
      : 'Mobile Wallet disconnected'
    return (
      <Context.Provider value={this._client}>
        <BNCClientConsumer>
          {bncClient => (
            <>
              <WalletConnectDelegateConfigurator
                bncClient={bncClient}
                walletConnectClient={this._client}
                isClientInitailized={this._client.initialized()}
                preSignCb={this._showSignModal}
                postSignCb={this._hideSignModal}
                errCb={this._hideSignModal}
              />
              {children}
            </>
          )}
        </BNCClientConsumer>
        {showModal ? (
          <Modal title={formatI18nText('walletConnect.readyToConfirm')} close={this._hideSignModal}>
            <ModalBody>{formatI18nText('walletConnect.readyToConfirmBody')}</ModalBody>
          </Modal>
        ) : null}
        {isWalletConnect && showNotify && (
          <Notifycation
            type={isConnectedWithWallet ? 'success' : 'fail'}
            msg={notifyMsg}
            title={'Status'}
            close={() => {
              this.setState({ showNotify: false })
            }}
          />
        )}
      </Context.Provider>
    )
  }
}

const mapStateToProps = ({
  globalData: { triggerElement },
  account: {
    address,
    flags: { isWalletConnect },
  },
  walletConnect: { isConnectedWithWallet },
}) => ({
  triggerElement,
  address,
  isWalletConnect,
  isConnectedWithWallet,
})

export const { Provider, Consumer } = Context

export default withI18n(connect(mapStateToProps)(WalletConnectProvider))
